import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { SharedModule } from 'app/shared/shared.module';
import { DocumentMeasurementComponent } from './document-measurement/document-measurement.component';
import { DocumentMeasurementDetailsComponent } from './document-measurement/details/document-measurement-details.component';
import { SiteMeasurementComponent } from './site-measurement/site-measurement.component';
import { SiteMeasurementDetailsComponent } from './site-measurement/details/site-measurement-details.component';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { ApprovedMeasurementDetailsComponent } from './approved-measurement/details/approved-measurement-details.component';
import { ApprovedMeasurementComponent } from './approved-measurement/approved-measurement.component';
import { BuiltUpAreaDetailsComponent } from './builtup-area/details/builtup-area-details.component';
import { BuiltUpAreaComponent } from './builtup-area/builtup-area.component';
import { BuiltUpAreaLandDetailsComponent } from './builtup-area-land/details/builtup-area-land-details.component';
import { BuiltUpAreaLandComponent } from './builtup-area-land/builtup-area-land.component';
import { ReplacementCostLandComponent } from './replacement-cost-land/replacement-cost-land.component';
import { ReplacementCostLandDetailsComponent } from './replacement-cost-land/details/replacement-cost-land-details.component';
import { ReplacementCostComponent } from './replacement-cost/replacement-cost.component';
import { ReplacementCostDetailsComponent } from './replacement-cost/details/replacement-cost-details.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { FuseAlertModule } from '@fuse/components/alert';
import { StatusChangeInwardComponent } from './status-change/statuschange-inward/status-change-inward.component';
import { UploadImagesComponent } from './upload-images/upload-images.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatCardModule } from '@angular/material/card';
import { InvoicePaymentListComponent } from './invoice-payment-list/invoice-payment-list.component';
import { GenerateReportComponent } from './generate-report/generate-report.component';
import { CopyReportComponent } from './copy-report/copy-report.component';
import { MatRadioModule } from '@angular/material/radio';
import { UploadMultipleImagesComponent } from './upload-multiple-images/upload-multiple-images.component';
import { WebcamModule } from 'ngx-webcam';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ReportBoundariesComponent } from './report-boundaries/report-boundaries.component';
import { MatTableModule } from '@angular/material/table';
import { LandAreaSiteMeasurementComponent } from './site-measurement/land-area/land-area-site-measurement.component';
import { BuiltupAreaSiteMeasurementComponent } from './site-measurement/builtup-area/builtup-area-site-measurement.component';
import { CarpetAreaSiteMeasurementComponent } from './site-measurement/carpet-area/carpet-area-site-measurement.component';
import { LandAreaApprovedMeasurementComponent } from './approved-measurement/land-area-approved-measurement/land-area-approved-measurement.component';
import { BuiltupAreaApprovedMeasurementComponent } from './approved-measurement/builtup-area-approved-measurement/builtup-area-approved-measurement.component';
import { CarpetAreaApprovedMeasurementComponent } from './approved-measurement/carpet-area-approved-measurement/carpet-area-approved-measurement.component';
import { CurrencyFormetDirectivesModule } from '@fuse/directives/Currency-Formet/currency-formet.module';
import { NumberOnlyDirectiveModule } from '@fuse/directives/number-only.directive.module';
import { OutwardFeesChangeRequestResultComponent } from './outward/outward-fees-change-request-result/outward-fees-change-request-result.component';

@NgModule({
        declarations: [
                DocumentMeasurementComponent,
                DocumentMeasurementDetailsComponent,
                SiteMeasurementComponent,
                SiteMeasurementDetailsComponent,
                ApprovedMeasurementComponent,
                ApprovedMeasurementDetailsComponent,
                BuiltUpAreaComponent,
                BuiltUpAreaDetailsComponent,
                BuiltUpAreaLandComponent,
                BuiltUpAreaLandDetailsComponent,
                ReplacementCostLandComponent,
                ReplacementCostLandDetailsComponent,
                ReplacementCostComponent,
                ReplacementCostDetailsComponent,
                StatusChangeInwardComponent,
                UploadImagesComponent,
                InvoicePaymentListComponent,
                GenerateReportComponent,
                CopyReportComponent,
                UploadMultipleImagesComponent,
                ReportBoundariesComponent,
                LandAreaSiteMeasurementComponent,
                BuiltupAreaSiteMeasurementComponent,
                CarpetAreaSiteMeasurementComponent,
                LandAreaApprovedMeasurementComponent,
                BuiltupAreaApprovedMeasurementComponent,
                CarpetAreaApprovedMeasurementComponent,
                OutwardFeesChangeRequestResultComponent
        ],
        imports: [
                MatButtonModule,
                MatIconModule,
                MatMenuModule,
                SharedModule,
                MatFormFieldModule,
                MatInputModule,
                MatSelectModule,
                MatAutocompleteModule,
                MatSlideToggleModule,
                MatDatepickerModule,
                FuseAlertModule,
                MatToolbarModule,
                MatProgressBarModule,
                MatGridListModule,
                MatCardModule,
                MatRadioModule,
                WebcamModule,
                MatCheckboxModule,
                DragDropModule,
                MatTableModule,
                CurrencyFormetDirectivesModule,
                NumberOnlyDirectiveModule
        ],

        exports: [
                DocumentMeasurementComponent,
                DocumentMeasurementDetailsComponent,
                SiteMeasurementComponent,
                SiteMeasurementDetailsComponent,
                ApprovedMeasurementComponent,
                ApprovedMeasurementDetailsComponent,
                BuiltUpAreaComponent,
                BuiltUpAreaDetailsComponent,
                BuiltUpAreaLandComponent,
                BuiltUpAreaLandDetailsComponent,
                ReplacementCostLandComponent,
                ReplacementCostLandDetailsComponent,
                ReplacementCostComponent,
                ReplacementCostDetailsComponent,
                StatusChangeInwardComponent,
                UploadImagesComponent,
                MatRadioModule,
                UploadMultipleImagesComponent,
                LandAreaSiteMeasurementComponent,
                BuiltupAreaSiteMeasurementComponent,
                CarpetAreaSiteMeasurementComponent,
                LandAreaApprovedMeasurementComponent,
                BuiltupAreaApprovedMeasurementComponent,
                CarpetAreaApprovedMeasurementComponent,
        ]
})
export class ComponentsModule {
}
